import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class UserName extends LitEntity {
  static get properites() {
    return {
      name: { type: String, attribute: false },
      hidePlaceholder: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (this.loading && !this.hidePlaceholder) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    return html`${this.name}`;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.name = this.entity ? this.entity.properties.name : '';
  }
}

window.customElements.define('user-name', UserName);
